export const leaveEncashableList = [
  {
    id: '01',
    name: 'True'
  },
  {
    id: '02',
    name: 'False'
  }
]

export const leaveType = [
  {
    id: '01',
    name: 'Leave'
  },
  {
    id: '02',
    name: 'Permission'
  },
]